export const makeNewClassName = (classNames: string[]) => classNames.join(" ")

export const appButtonTWS =
  "flex items-center px-4 py-2 sm:py-2 leading-none transition duration-100"
export const darkAppButtonTWS =
  "bg-site-blue-dark text-white button-bg-site-blue-dark"
export const roundedAppButtonTWS = "rounded-full"
